import styled from 'styled-components';
import Link from 'next/link';
import { black } from 'Styles/colors';
import { fontTitle, fontBody } from 'Styles/fonts';

import Drawer from '../../../Drawer/Drawer';
import NotificationIcon from '../../../Icons/NotificationIcon/NotificationIcon';
import FreeShippingOriginal from '../../../FreeShipping/FreeShipping';
import ProductVariantOriginal from '../../../ProductVariant/ProductVariant';
import CartFooterOriginal from '../CartFooter/CartFooter';
import ConfirmationCardOriginal from '../../../ConfirmationCard/ConfirmationCard';
import GiftMessageCardEditOriginal from '../../../GiftMessageCard/components/GiftMessageCardEdit/GiftMessageCardEdit';
import GiftMessageCardAddOriginal from '../../../GiftMessageCard/components/GiftMessageCardAdd/GiftMessageCardAdd';
import {
  Title,
  Description,
  CtaButton
} from '../../../GiftMessageCard/components/GiftMessageCardAdd/GiftMessageCardAdd.styled';

export const GiftMessageCardEdit = styled(GiftMessageCardEditOriginal)`
  margin-bottom: 16px;
`;

export const GiftMessageCardAdd = styled(GiftMessageCardAddOriginal)`
  margin-bottom: 16px;

  ${Title} {
    ${fontTitle(14)}
  }

  ${Description} {
    ${fontBody(14)}
  }

  ${CtaButton} {
    ${fontBody(16)}
  }
`;

export const CartDialog = styled(Drawer)`
  padding: 0 8px;
  display: flex;
  flex-direction: column;
`;

export const CartNotificationIcon = styled(NotificationIcon)`
  top: -12px;
  cursor: pointer;
`;

export const FreeShipping = styled(FreeShippingOriginal)`
  padding: 0 16px;
`;

export const EmptyCartTitle = styled.h1`
  ${fontTitle(18)};
  color: ${black};
  text-align: center;
  margin: 24px 0;
  width: 343px;
`;

export const CartLineItems = styled.div`
  margin-top: 16px;
  padding: 0 16px;
`;

export const ProductVariant = styled(ProductVariantOriginal)`
  margin-bottom: 16px;
`;

export const ProductVariantWrapper = styled.div`
  overflow: hidden;
  transition: all ${({ transitionDuration }) => transitionDuration}ms
    cubic-bezier(0.25, 1, 0.25, 1);

  &:last-of-type > ${ProductVariant} {
    margin-bottom: 0;
  }

  &.fade-enter {
    opacity: 0;
    max-height: 0;
  }
  &.fade-enter-active {
    opacity: 1;
    max-height: 200px;
  }
  &.fade-exit {
    opacity: 1;
    max-height: 200px;
  }
  &.fade-exit-active {
    opacity: 0;
    max-height: 0;
  }
`;

export const ScrollContainer = styled.div`
  flex: auto;
  overflow-y: scroll;
`;

export const CartFooter = styled(CartFooterOriginal)`
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  margin: 0 -8px;
  bottom: 0;
  box-shadow: 0 -1px 8px 0 rgba(128, 148, 148, 0.15);
  z-index: 10;
`;

export const ConfirmationCardWrapper = styled.div`
  height: auto;
  transition: all ${({ transitionDuration }) => transitionDuration}ms
    cubic-bezier(0.25, 1, 0.25, 1);

  &.fade-enter {
    opacity: 0;
    max-height: 0;
  }
  &.fade-enter-active {
    opacity: 1;
    max-height: 100px;
  }
  &.fade-exit {
    opacity: 1;
    max-height: 100px;
  }
  &.fade-exit-active {
    opacity: 0;
    max-height: 0;
  }
`;

export const ConfirmationCard = styled(ConfirmationCardOriginal)`
  margin-bottom: 16px;
`;

export const CartPageLink = styled(Link)`
  text-decoration: none;
`;
